import React from "react";
import { AlertTriangle } from "lucide-react";
import { cryptoGuide } from "../mock";

const CryptoGuide = () => {
  const { title, subtitle, option, important, footnote } = cryptoGuide;
  return (
    <section className="py-24 bg-[#0a101e] border-t border-white/5">
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-14">
          <h2 className="font-pixel pixel-white text-2xl sm:text-3xl lg:text-4xl">{title}</h2>
          <p className="text-slate-400 text-lg mt-5">{subtitle}</p>
        </div>

        <div className="bg-[#0f1a30] border border-yellow-400/30 rounded-2xl p-7">
          <h3 className="text-yellow-400 font-semibold text-lg mb-5">{option.heading}</h3>
          <ol className="space-y-3">
            {option.steps.map((s, i) => (
              <li key={i} className="flex gap-3 text-slate-200">
                <span className="w-6 h-6 rounded-md bg-yellow-400/15 border border-yellow-400/40 text-yellow-400 text-sm flex items-center justify-center shrink-0">
                  {i + 1}
                </span>
                <span className="leading-relaxed">{s}</span>
              </li>
            ))}
          </ol>
        </div>

        <div className="bg-[#0f1a30] border border-red-500/40 rounded-2xl p-7 mt-7">
          <h3 className="flex items-center gap-2 text-red-400 font-semibold text-lg mb-5">
            <AlertTriangle className="w-5 h-5" /> {important.heading}
          </h3>
          <ul className="space-y-3">
            {important.notes.map((n, i) => (
              <li key={i} className="flex gap-3 text-slate-300">
                <span className="text-red-400">&bull;</span>
                <span className="leading-relaxed">{n}</span>
              </li>
            ))}
          </ul>
        </div>

        <p className="text-center text-slate-500 text-sm mt-8">{footnote}</p>
      </div>
    </section>
  );
};

export default CryptoGuide;
